/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InsuredType {
  EMPLOYEE = 'EMPLOYEE',
  SPOUSE_OR_DOMESTIC_PARTNER = 'SPOUSE_OR_DOMESTIC_PARTNER',
  CHILD_OR_OTHER_DEPENDENT = 'CHILD_OR_OTHER_DEPENDENT',
}
